module.exports = __webpack_public_path__ + "static/media/p208ge.d5cb0188.jpg";